// extracted by mini-css-extract-plugin
module.exports = {"cursor":"cursor-module--cursor--1P1y6","cursorSmall":"cursor-module--cursor--small--1EVKm","cursorHover":"cursor-module--cursor--hover--1ixBt"};